'use client';

import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { MultiSelectDropdown } from '../../../OffersFilter/MultiSelectDropdown';
import { useFilterEvents } from '../../../OffersFilter/useFilterEvents';
import { useRangeFilterOptions } from '../store/hooks';
import { useOffersFilterStore } from '../store/useOffersFilterStore';

export const TermLengthSelect = ({
  isStickyBar = false,
  scrollBackToMainBar,
  actionSection,
  pageIdentifier,
}: {
  isStickyBar?: boolean;
  scrollBackToMainBar?: () => void;
  actionSection: string;
  pageIdentifier: string;
}) => {
  const options = useRangeFilterOptions('cdDepositTerm');
  const { handleUpdateFilterFormState, handleApplyFilters, appliedFilters } = useOffersFilterStore(
    ({ handleUpdateFilterFormState, handleApplyFilters, appliedFilters }) => ({
      handleUpdateFilterFormState,
      handleApplyFilters,
      appliedFilters,
    }),
    shallow,
  );
  const { updateFiltersEvent } = useFilterEvents({
    actionSection,
    pageIdentifier,
    additionalAttributes: {},
  });

  const handleChange = useCallback(
    (selectedLabels: string[]) => {
      if (scrollBackToMainBar) scrollBackToMainBar();
      setTimeout(
        () => {
          handleUpdateFilterFormState({ selectedTermRanges: selectedLabels });
          const newState = handleApplyFilters();
          if (!newState) return;
          updateFiltersEvent({
            additional_attributes: {
              term_length: selectedLabels,
              min_deposit: newState.appliedFilters.selectedMinDepositRanges,
            },
          });
        },
        scrollBackToMainBar ? 100 : 0,
      );
    },
    [handleUpdateFilterFormState, handleApplyFilters, updateFiltersEvent, scrollBackToMainBar],
  );

  return (
    <MultiSelectDropdown
      isStickyBar={isStickyBar}
      label="Term Length"
      options={options}
      selectedOptions={appliedFilters?.selectedTermRanges || []}
      onChange={handleChange}
      useStore={useOffersFilterStore}
    />
  );
};
